import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import {useDebtPaymentPopupData} from '../../hooks/useDebtPaymentPopupData';
import {stepEnum} from '../../Constants/debtPaymentEnum';
import {selectSelectedBanData, selectServerData, selectEpiData} from '../../DebtAndUpdatePaymentBlockSlice';
import {dwhUpdatePaymentMethodReport, DwhActionType, DWHMessageText, DWHStatus} from '../../reports/dwhReports';
import {isMobile} from 'react-device-detect';
import Image from 'app/Components/Shared/Image/image';

const DebtFirstPopupMax = () => {
  const {actions} = useDebtPaymentPopupData();
  const selectedBanData = useSelector(selectSelectedBanData);
  const allBans = useSelector(selectServerData);
  const epiData = useSelector(selectEpiData);
  const loginData = useSelector((state) => state.authentication.loginData);

  useEffect(() => {
    dwhUpdatePaymentMethodReport({
      banData: selectedBanData,
      loginData,
      allBans,
      actionType: DwhActionType.MustPayExistingDebtPopup,
      messageText: DWHMessageText.MustPayExistingDebtPopupDisplayed,
      status: DWHStatus.Ongoing,
      lastPaymentTypeValidation: epiData?.lastPaymentTypeValidation,
    });
  }, []);

  function handleCallToService() {
    window.location.href = 'tel:*'+ window.Config.technicalSupportPhone;
  }
  function handleClick() {
    if (isMobile) {
      handleCallToService();
    } else {
      actions.setShowPopup({showPopUp: false});
    }
  }
  return (
    <div>
      <div className='debt-payment-popup-image'>
        <Image src={require('../../images/error.svg')} alt='' />
      </div>
      <div className={`popup-title ${isMobile ? 'm-title' : 'l-title'}`}> בשל גובה החוב לא ניתן להתקדם</div>
      <div className='popup-sub-title s-title'> נוכל לסייע לך להסדיר את החוב</div>
      {!isMobile && <div className='popup-connect-us s-title'>חייגו {window.Config.technicalSupportPhone} לנציג שירות </div>}
      <div className='debt-payment-popup-actions'>
        <BtnSubmit onclick={handleClick} text={isMobile ? 'חייגו *'+ window.Config.technicalSupportPhone + ' לנציג שירות' : 'הבנתי, תודה'} />
      </div>
    </div>
  );
};

export default DebtFirstPopupMax;
